import { NgModule } from '@angular/core';

import { ClientLayoutComponent } from './client-layout.component';
import { SharedModule } from '../_shared/shared.module';
import { ClientHeaderComponent } from './_shared/client-header/client-header.component';
import { KycBannerComponent } from './_shared/kyc-banner/kyc-banner.component';
import { PageSidebarMenuComponent } from '../_shared/components/page-sidebar/page-sidebar-menu.component';

@NgModule({
    imports: [
        SharedModule,
        ClientHeaderComponent,
        KycBannerComponent,
        PageSidebarMenuComponent,
        ClientLayoutComponent,
    ],
})
export class ClientLayoutModule {}
